import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface HourlyGenerationStatsResponse {
  date: Date;
  items: Array<Items>;
};

export interface Items {
  hour: number;
  count: number;
};


export class StatsItemsData {
  @Required("Hour cannot be empty")
  @IsNumber("Hour must be a number")
  hour: number;

  @Required("Count cannot be empty")
  @IsNumber("Count must be a number")
  count: number;
}

export class HourlyGenerationStatsData {
  @Required("items cannot be empty")
  @IsArray("items must be an array")
  items: StatsItemsData[];
  
  // @Required("Date cannot be empty")
  @IsString("Date must be a string")
  date: string;
}

const transformAndValidateAgent = (
  response: HourlyGenerationStatsResponse
): HourlyGenerationStatsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, HourlyGenerationStatsData);
  } catch (error) {
    console.error("Agent User Hourly Generation Stats data validation failed:", error.message);
    throw error;
  }
};

/** 内容管理 - 24小时生成统计 */
export const hourlyGenerationStats = async ({
  date,
  agentId,
}: { date: string, agentId: string }): Promise<HourlyGenerationStatsData> => {
  const response = await api.post<HourlyGenerationStatsResponse>('/agent-v2/user-stats/hourly-generation', {
    date,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
